export class SearchResult {
    public Address: string;
    public BrandNames: string;
    public Category: string;
    public CategoryTooltip: string;
    public City: string;
    public CoId: string;
    public Company: string;
    public CompanyEmail: string;
    public CompanyType: string;
    public Country: string;
    public Description: string;
    public Designation: string;
    public FullName: string;
    public Id: string;
    public IndividualEmail: string;
    public IsAwardWinner: boolean;
    public IsExpressShipper: boolean;
    public IsMember: boolean;
    public IsMinorityOwned: boolean;
    public IsPsa: boolean;
    public IsUnion: boolean;
    public IsUSMade: boolean;
    public IsVeteranOwned: boolean;
    public IsWomanOwned: boolean;
    public Logo: string;
    public MemberType: string;
    public Phone: string;
    public Products: string;
    public RecordType: string;
    public Score: number;
    public State: string;
    public Title: string;
    public TollFree: string;
    public Upic: string
    public Website: string;
    public Zip: string;

    public FirstName: string;
    public LastName: string;
    public IsCompany: boolean;

    constructor(
        address: string,
        category: string,
        city: string,
        coid: string,
        company: string,
        country: string,
        description: string,
        designation: string,
        phone: string,
        tollFree: string,
        logoPath: string,
        firstName: string,
        lastName: string,
        state: string,
        zip: string,
        id: string,
        companyEmail: string,
        individualEmail: string,
        isCompany: boolean,
        isMember: boolean,
        isPsa: boolean,
        isAwardWinner: boolean,
        companyType: string,
        website: string,
        score: number,
        recordType: string,
        products: string,
        brandNames: string,
        title: string,
        upic: string,
        memberType: string
    ) {
        this.Address = address,
        this.Category = category,
        this.City = city,
        this.CoId = coid,
        this.Company = company,
        this.Country = country,
        this.Description = description,
        this.Designation = designation,
        this.Phone = phone,
        this.TollFree = tollFree,
        this.Logo = logoPath,
        this.FirstName = firstName,
        this.LastName = lastName,
        this.State = state,
        this.Zip = zip,
        this.Id = id,
        this.CompanyEmail = companyEmail,
        this.IndividualEmail = individualEmail,
        this.IsCompany = isCompany,
        this.IsMember = isMember,
        this.IsPsa = isPsa,
        this.IsAwardWinner = isAwardWinner,
        this.CompanyType = companyType,
        this.Website = website,
        this.Score = score,
        this.RecordType = recordType,
        this.Products = products,
        this.BrandNames = brandNames,
        this.Title = title,
        this.Upic = upic,
        this.FullName = firstName + ' ' + lastName,
        this.MemberType = memberType
    }
}
